export default "<tui-root>\n    <tui-doc-example [content]=\"example\">\n        <example></example>\n    </tui-doc-example>\n</tui-root>\n";